import { useEffect } from 'react';
import { init } from '@cmctechnology/webinvest-analytics-compat';
import { useDispatch } from 'react-redux';
import { createConfig } from '../configuration/configuration';
import { updateAnalyticsEnabled } from '../Store/Actions';

export const useAnalyticsInit = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const initAnalytics = async () => {
      try {
        await init(createConfig().analytics);
        dispatch(updateAnalyticsEnabled(true));
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    };
    initAnalytics();
  }, []);
};
